<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'订单详情'}]" style="width:100%"/>
        <div class="h-piece" v-if="clickActive == 1">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2 name">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine neixiao">
                        <el-form label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine inputO">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-input v-model="orderProjectName" placeholder="未关联项目"
                                          class="zidaoO" readonly></el-input>
                            </el-form-item>

                            <el-form-item label="主合同编号" class="h-elformWrap-2 ">
                                <el-input v-model="orderMainContract" placeholder="未关联项目" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="分合同编号" class="h-elformWrap-2">
                                <el-input v-model="orderSubContract" placeholder="未关联项目" readonly></el-input>
                            </el-form-item>

                            <el-form-item label="报价单" class="h-elformWrap-2" v-if="showPO">
                                <brupload
                                        :refid = "q.id"
                                        :reftype = "wxpi"
                                >
                                </brupload>
                            </el-form-item>

                            <el-form-item label="PO凭证" class="h-elformWrap-2" v-if="showPO">
                                <brupload
                                        :refid = "q.id"
                                        :reftype = "wxpo"
                                >
                                </brupload>
                            </el-form-item>
                           

                            <div class="h-pieceTitle2">
                                <h1>订单信息</h1>
                            </div>

                            <el-form-item label="销售区域" class="h-elformWrap-2">
                                <brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
                                          v-model="formInline.orderCategory" disabled></brselect>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <brselect style="width: 169px" category="xiaoshou_zuzhi" :v="formInline.saleGroupCode"
                                          v-model="formInline.saleGroupCode" disabled></brselect>
                            </el-form-item>

                            <el-form-item label="分销渠道" class="h-elformWrap-2">
                                <brselect style="width: 166px" category="fenxiao_qudao"
                                          :v="formInline.disChannelCode"
                                          v-model="formInline.disChannelCode" disabled></brselect>
                            </el-form-item>

                            <el-form-item label="二级分销渠道" class="h-elformWrap-2" v-if="yincang">
                                <brselect style="width: 150px" category="z1_xuanxiang" :v="formInline.zCode"
                                          v-model="formInline.zCode" disabled></brselect>
                            </el-form-item>

                            <div class="h-pieceTitle2">
                                <h1>客户信息</h1>
                            </div>
                            <div class="">
                                <div class="h-formLine n-two">
                                    <el-form label-position="right" :inline="true"
                                        class="demo-ruleForm h-formbLine">
                                        <el-form-item prop="customerChannelCode" label="客户渠道"
                                                      class="h-elformWrap-2">
                                            <brselect clearable category="sales_region" :v="formInline.customerChannelCode"
                                                      v-model="formInline.customerChannelCode" disabled></brselect>
                                        </el-form-item>
                                        <el-form-item prop="contactName" label="收货联系人" class="h-elformWrap-2">
                                            <el-input v-model="formInline.contactName" placeholder="请输入"
                                                      readonly></el-input>
                                        </el-form-item>
                                        <el-form-item
                                                label="预计收货日期"
                                                class="h-elformWrap-2"
                                                width="120px"
                                                prop="receivedTime">
                                            <div class="block">
                                                <el-date-picker
                                                        v-model="formInline.receivedTime"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="--选择--"
                                                        :picker-options="pickerOptions" disabled>
                                                </el-date-picker>
                                            </div>
                                        </el-form-item>
                                        <el-form-item label="收货地址" style="margin-left:-1.9rem">
                                            <div class="block">
                                                <el-input v-model="formInline.toAddress" placeholder="请选择" readonly
                                                    style="width:7.6rem"
                                                ></el-input>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>

                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30    bbbb" v-if="clickActive==1">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">订单详情</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData3"
                    stripe
					border
                    style="width: 100%">
                <!--                <el-table-column-->
                <!--                        type="selection"-->
                <!--                        width="70"-->
                <!--                        label="全选">-->
                <!--                </el-table-column>-->
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>

                <el-table-column
                        prop="materialCode0"
                        label="产品编码"
                        >
                </el-table-column>
                <el-table-column
                        prop="proModelCode0"
                        label="产品型号"
                        >
                </el-table-column>
                <el-table-column
                        prop="proNumber0"
                        label="订单数量"
                       >
                </el-table-column>
                <el-table-column
                        prop="proBenchmarkPrice0"
                        label="基准价"
                        >
                </el-table-column>
                <el-table-column
                        prop="specialPrice"
                        label="特价"
                        >
                </el-table-column>

<!--                <el-table-column-->
<!--                        prop="isStockUp"-->
<!--                        label="是否备货"-->
<!--                        >-->
<!--                    <template slot-scope="scope">-->
<!--                        <dictname category="shifou_keyong"  :v="scope.row.isStockUp"/>-->
<!--                    </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column-->
<!--                        prop="spare3"-->
<!--                        label="定制需求"-->
<!--                        >-->
<!--                </el-table-column>-->

<!--                <el-table-column-->
<!--                        prop="extraPrice"-->
<!--                        label="定制加价"-->
<!--                       >-->
<!--                </el-table-column>-->

                <el-table-column
                        prop="finalPrice0"
                        label="成交价"
                        >
                </el-table-column>

                <el-table-column
                        prop="totalPrice"
                        label="总价"
                       >
                </el-table-column>

            </el-table>
        </div>

        <div class="h-piece" v-if="clickActive==2">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2 name">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine neixiao">
                        <el-form label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine inputO">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-input v-model="orderProjectName" placeholder="未关联项目"
                                          class="zidaoO"></el-input>
                            </el-form-item>

                            <el-form-item label="主合同编号" class="h-elformWrap-2 ">
                                <el-input v-model="orderMainContract" placeholder="未关联项目"></el-input>
                            </el-form-item>
                            <el-form-item label="分合同编号" class="h-elformWrap-2">
                                <el-input v-model="orderSubContract" placeholder="未关联项目"></el-input>
                            </el-form-item>

                            <div class="xiangmu">
                                <div class="h-pieceTitle2">
                                    <h1>订单信息</h1>
                                </div>

                                <el-form-item label="销售区域" class="h-elformWrap-2">
                                    <brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
                                              v-model="formInline.orderCategory"></brselect>
                                </el-form-item>
                                <el-form-item label="销售组织" class="h-elformWrap-2">
                                    <brselect style="width: 169px" category="xiaoshou_zuzhi"
                                              :v="formInline.saleGroupCode"
                                              v-model="formInline.saleGroupCode"></brselect>
                                </el-form-item>

                                <el-form-item label="分销渠道" class="h-elformWrap-2">
                                    <brselect style="width: 169px" category="fenxiao_qudao"
                                              :v="formInline.disChannelCode"
                                              v-model="formInline.disChannelCode"></brselect>
                                </el-form-item>

                                <el-form-item label="二级分销渠道" class="h-elformWrap-2" v-if="yincang">
                                    <brselect style="width: 150px" category="z1_xuanxiang" :v="formInline.zCode"
                                              v-model="formInline.zCode"></brselect>
                                </el-form-item>

                                <div class="h-pieceTitle2">
                                    <h1>客户信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine n-two">
                                        <el-form label-position="right" :inline="true"
                                                 class="demo-ruleForm h-formbLine">

                                            <el-form-item prop="customerChannelCode" label="客户渠道"
                                                          class="h-elformWrap-2">
                                                <brselect clearable category="sales_region"
                                                          :v="formInline.customerChannelCode"
                                                          v-model="formInline.customerChannelCode"></brselect>
                                            </el-form-item>
                                            <el-form-item prop="contactName" label="收货联系人" class="h-elformWrap-2">
                                                <el-input v-model="formInline.contactName" placeholder="请输入"></el-input>
                                            </el-form-item>

                                            <el-form-item
                                                    label="预计收货日期"
                                                    class="h-elformWrap-2"
                                                    width="120px"
                                                    prop="receivedTime">
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="formInline.receivedTime"
                                                            type="date"
                                                            value-format="yyyy-MM-dd"
                                                            placeholder="--选择--"
                                                            :picker-options="pickerOptions">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>

                                            <el-form-item label="收货地址" width="5rem">
                                                
                                                    <el-input v-model="formInline.toAddress" placeholder="请选择" style="width:3rem"
                                                    ></el-input>
                                                
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>

                            </div>


                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30    bbbb" v-if="clickActive==2">
            <div class="h-pieceTitle2 message">
                <h1 class="h1">项目产品信息</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData3"
					border
                    >
                <!--                <el-table-column-->
                <!--                        type="selection"-->
                <!--                        width="70"-->
                <!--                        label="全选"-->
                <!--                        @change="getAllTotalPrice(multipleSelection)">-->
                <!--                </el-table-column>-->
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>

                <el-table-column
                        prop="materialCode0"
                        label="产品编码"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="proModelCode0"
                        label="产品型号"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="proNumber0"
                        label="订单数量"
                        width="110"
                        :rules="[
								  { required: true, message: '请输入排序名称'},
								  { type: 'number', message: '必须为数字值',trigger: 'change'}
								]">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.proNumber0" @change="getTotalPrice(scope.row)"
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proBenchmarkPrice0"
                        label="基准价"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="specialPrice"
                        label="特价"
                        width="100">
                </el-table-column>

<!--                <el-table-column-->
<!--                        prop="isStockUp"-->
<!--                        label="是否备货"-->
<!--                        width="100">-->
<!--                    <template scope="scope">-->
<!--                        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">-->
<!--                            <el-form-item label="">-->
<!--                                <el-select v-model="scope.row.isStockUp" >-->
<!--                                    <el-option label="是" value="1"></el-option>-->
<!--                                    <el-option label="否" value="0"></el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
<!--                        </el-form>-->
<!--                    </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column-->
<!--                        prop="spare3"-->
<!--                        label="定制需求"-->
<!--                        width="100">-->
<!--                    <template scope="scope">-->
<!--                        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">-->
<!--                            <el-form-item label="">-->
<!--                                <el-select v-model="scope.row.spare3" style="width:1.5rem;"-->
<!--                                           :disabled="scope.row.cflag">-->
<!--                                    <el-option label="外壳镀金" value="1"></el-option>-->
<!--                                    <el-option label="功率提升" value="2"></el-option>-->
<!--                                    <el-option label="不定制" value="0"></el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
<!--                        </el-form>-->
<!--                    </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column-->
<!--                        prop="extraPrice"-->
<!--                        label="定制加价"-->
<!--                        width="200">-->
<!--                </el-table-column>-->

                <el-table-column
                        prop="finalPrice0"
                        label="成交价"
                        width="140">
                </el-table-column>

                <el-table-column
                        prop="totalPrice"
                        label="总价"
                        >
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                       <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                v-model="scope.row.pid"
                                @click="deleteThis(scope.row.pid)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row.pid)"></span>
						</div> -->
                    </template>
                </el-table-column>

            </el-table>
        </div>

        <div class="jieguo">
            <span class="bizhong">币种</span>
            <span class="renminbi" style="width:2.3rem;">{{ currencyCode }}</span>
            <span class="dingdan">订单总价</span>
            <span class="yuan" style="width:2.3rem;">{{ allTotalPrice }}</span>
            <!--            <span class="xianjin">现金余额</span>-->
            <!--            <span class="money">{{ cashBalance }}</span>-->
            <span class="xianjin">现金占用</span>
            <span class="money" style="width:2.3rem;">{{ cashOccupy }}</span>
            <!--            <span class="xianjin">信贷余额</span>-->
            <!--            <span class="zhangqi">{{ creditBalance }}</span>-->
            <span class="xianjin">信贷占用</span>
            <span class="zhangqi" style="width:2.3rem;">{{ creditOccupy }}</span>
            <span class="jiazhi">净价值</span>
            <span class="make" style="width:2.3rem;">{{n.netPrice}}</span>
        </div>

        <!--查看跟踪审批流组件： showhistory：打开流程框，instid：流程id-->
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        
        <div class="apprButton">
            <el-row>
                <el-button class="refuse" @click="createNewOrder()" v-if="showS">提交修改</el-button>
                <el-button class="pass" @click="edit" v-if="showS">编辑详情</el-button>
<!--                <el-button class="pass" @click="findDetail">查看审批详情</el-button>-->
            </el-row>
        </div>

    </div>
</template>
<style scoped>
    /* .xiangmu{
        margin-top: -23px;
    } */

    /*--------------- 审批样式 ----------------*/

    .redStar {
        position: absolute;
        top: 90%;
        left: 1%;
        color: red;
        font-size: 0.2rem;
    }

    .yijianbixutian {
        position: absolute;
        top: 1%;
        left: 15%;
        color: red;
    }


    .apprButton {
        margin-left: 6rem;
        margin-top: 30px;
    }

    .cancel {
        width: 18%;
    }

    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }

    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }

    /*--------------- 审批样式 ------------------*/

    .rightstep {
        width: 170px;
        height: 5px;

        background-blend-mode: normal,
        normal;
        position: relative;
    }

    .rightstep.rightstep1 {
        background-image: linear-gradient(-90deg,
        #0056a4 0%,
        #0056a4 100%),
        linear-gradient(
                #0056a4,
                #0056a4);
    }

    .readiu {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        position: relative;
        left: 74px;
        top: -12px;
        background-color: white;
    }

    .readiu.readiu1 {
        border: 3px solid #0056a4;
    }

    .fukuan {
        width: 170px;
        height: 5px;
        background-color: #c7c8ca;
        position: relative;
    }

    .fukuan.fukuan1 {
        background-color: #0056a4;
        color: #0056a4;
    }

    .color {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        border: 3px solid #c7c8ca;
        position: relative;
        left: 74px;
        top: -12px;
        background-color: white;
    }

    .color.color1 {
        border: solid 2px #0056a4;
    }

    .fuwu {
        width: 48px;
        height: 50px;
        background-color: white;
        border-radius: 4px;
        border: solid 2px #c7c8ca;
        font-size: 15px;
        color: #c7c8ca;
        text-align: center;
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;
    }

    .fuwu.fuwu1 {
        border: solid 2px #0056a4;
        color: #b3bcc7;
    }

    .stepBox .leftstep.leftstep1 {
        border: solid 2px #0056a4;
        color: #0056a4;
    }

    .leftstep {
        width: 48px;
        height: 50px;
        background-color: #fcfcfc;
        border-radius: 4px;
        font-size: 15px;
        text-align: center;
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;
        border: solid 2px #c7c8ca;
        color: #c7c8ca;
    }

    img {
        width: 22px;
        padding: 1px 0;
        margin-left: 0.017rem;
        /* margin-top: -3px; */
        color: block;
    }

    .name {
        margin-left: 9px;
        /* margin-top: -24px; */
    }

    .fanhui {
        padding: 15px 35px;
        color: white;
        background-color: #006aca;
    }

    .F-H {
        margin-top: 15px;
        margin-left: 8rem;
    }

    .icon {
        margin: 0 20px;
    }

    .stepBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-left: 3%;
    }

    .stepBox .step {
        width: 16%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .stepBox .step:last-child {
        width: 100px;
    }

    .stepBox .step .leftstep {
        width: 48px;
        height: 50px;
        background-color: #fcfcfc;
        border-radius: 4px;
        border: solid 2px #0e75e9;
        font-size: 15px;
        color: #0e75e9;
        text-align: center;
        /* padding: 16px 0; */
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;

    }

    .stepBox .step .leftstep .times {
        width: 140px;
        position: absolute;
        top: 120px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #595959;
    }

    .stepBox .step .rightstep {
        width: 170px;
        height: 5px;
        background-image: linear-gradient(-90deg,
        #0056a4 0%,
        #3291fd 100%),
        linear-gradient(
                #0e75e9,
                #0e75e9);
        background-blend-mode: normal,
        normal;
        position: relative;
    }

    .stepBox .step .rightstep .circle {
        width: 23px;
        height: 23px;
        background-color: #fcfcfc;
        border: 2px solid #3291fd;
        overflow: hidden;
        border-radius: 50%;
        position: absolute;
        top: -9px;
        left: 63%;
        transform: translateX(-25px);
    }

    /*.stepBox .step .rightstep .circle img {*/
    /*    position: absolute;*/
    /*    top: 0;*/
    /*    left: 0;*/
    /*    right: 0;*/
    /*    bottom: 0;*/
    /*    margin: auto;*/
    /*    width: 15px;*/
    /*}*/

    .make {
        width: 110px;
        padding-left: 17px;
    }

    .jiazhi {
        width: 100px;
        padding-left: 20px;
    }

    .zhangqi {
        width: 168px;
        padding-left: 10px;
    }

    .yuan, .zhanyong, .money, .xianjin, .dingdan {
        width: 120px;
        padding-left: 20px;
    }


    .renminbi {
        width: 90px;
        padding-left: 20px;
    }

    .bizhong {
        width: 72px;
        padding-left: 20px;

    }

    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }

    .bizhong,
    .dingdan,
    .xianjin,
    .zhanyong,
    .jiazhi {
        background-color: #ebf5ff;
        font-size: 10px;
    }

    .bizhong,
    .renminbi,
    .dingdan,
    .money,
    .xianjin,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding: 20px 0;
        padding-left: 18px;
        border-bottom: 1px solid rgb(223, 222, 222);
        border-right: 1px solid rgb(236, 236, 236);
    }

    .jieguo {
        margin-top: 12px;
        display: flex;
        margin: 0 20px;

    }

    /*span {*/
    /*    color: white;*/
    /*    position: relative;*/
    /*    top: -12px;*/
    /*    left: 20px;*/
    /*    font-size: 14px;*/
    /*}*/

    /*img {*/
    /*    width: 25px;*/
    /*    padding: 5px 0;*/
    /*    margin-left: 8rem;*/
    /*}*/

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }

    .h-crumbOut {
        margin-bottom: 20px;
    }

    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .bbbb {
        padding-top: 5px;
        margin: 10px 20px 0 20px;
    }

    .neixiao .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>
    /* .el-table__body .el-table__row .cell {
        padding: 0;
        height: 40px;
        line-height: 40px;
    } */

    .neixiao .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .neixiao .h-formbLine .el-form-item__content {
        width: 57%;
    }

    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after{
     content: "全选";
     color:white;
     background-color: rgb(93, 172, 236);
     font-size: 10px;
     } */


</style>

<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'

    export default {

        //顶部审核状态改变
        topChange() {
            switch (this.tableData.orderStatus) {
                case '20':
                    break;
                case "24":
                    this.showimg2 = true;
                    this.fuwu = true;
                    break;
                default:
                    break;
            }
        },


        created() {
            this.q.orderId = this.$route.query.orderId || this.$route.query.ywid;
            this.queryMoney(this.q.orderId);
            this.q.taskid = this.$route.query.taskid;
            this.tableData2.taskId = this.q.taskid;
            this.tableData2.orderId = this.q.orderId;
            this.query();
           
        },
        mounted() {
        },

        methods: {
            
            //查看审批流详情
            findDetail(){
                this.showhistory = true;
            },

            //删除该行项目产品信息
            deleteThis(x) {
                this.tableData2 = _.reject(this.tableData2, {'pid': x});
            },

            hidden(index) {
                if (index === 6) {
                    this.show = fasle;
                }
            },

            //查询余额
            queryMoney(x) {
                ss.OrderService.queryMoneyByOrderCode(x).then(rd => {
                    this.cashBalance = rd.obj.cashBalance;
                    this.creditBalance = rd.obj.creditBalance;
                });
            },
            //查询信贷
            getCredit() {
                this.params1.saleGroupCode = this.formInline.saleGroupCode;
                this.params1.orderProductList = this.tableData3;

                this.params1.orderProductList.forEach((item, index) => {
                    item.materialCode = item.materialCode0;
                })
                this.params1.usercode = this.tableData3[0].soldToCode;
                ss.OrderService.getCredit(this.params1).then(rd => {
                    this.creditData = rd;
                })
            }
            ,

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.getAllTotalPrice(val);
            },

            query() {
                ss.OrderService.getSingleOrderDetail(this.q).then(rd => {
                    this.tableData3 = rd;
                    this.orderProjectName = this.tableData3[0].orderProjectName;

                    this.orderMainContract = this.tableData3[0].orderMainContract;
                    this.orderSubContract = this.tableData3[0].orderSubContract;

                    this.formInline.zCode = this.tableData3[0].zCode;
                    this.formInline.saleGroupCode = this.tableData3[0].saleGroupCode;
                    this.formInline.orderCategory = this.tableData3[0].orderCategory;
                    this.formInline.disChannelCode = this.tableData3[0].disChannelCode;
                    this.formInline.toAddress = this.tableData3[0].toAddress;
                    this.formInline.contactName = this.tableData3[0].contactName;
                    this.formInline.receivedTime = this.tableData3[0].receivedTime;
                    this.formInline.customerChannelCode = this.tableData3[0].customerChannelCode;
                    this.currencyCode = this.tableData3[0].currencyCode;
                    
                    this.formInline.orderCategory1 = this.tableData3[0].orderCategory1;
                    this.getCredit();
                    this.getETotalPrice(this.tableData3);
                    if (this.formInline.disChannelCode == 'Z1') {
                        this.yincang = true;
                    }
                    
                    if(this.formInline.orderCategory1 == '21' || this.formInline.orderCategory1 == '22'){
                        this.showPO = true;
                    }
                    
                    if(this.tableData3[0].orderStatus == '22' || this.tableData3[0].orderStatus == '23' 
                        || this.tableData3[0].orderStatus == '10'){
                        this.showS = true;
                    }

                });
                //this.tableData.orderStatus = 24;
            },
            //数量改变-总价改变
            getTotalPrice(n) {
                var c = 0;
                if (n.specialPrice != '' && n.specialPrice != null) {
                    if (n.specialPrice > 0) {
                        c = new big(n.specialPrice).plus(n.extraPrice || '0');
                    } else {
                        c = new big(n.finalPrice).plus(n.extraPrice || '0');
                    }
                } else {
                    c = n.finalPrice;
                }
                n.proNumber0 = n.proNumber0 == '' ? 0 : n.proNumber0;
                n.totalP = new big(n.proNumber0).times(c);
                n.totalPrice = (n.totalP).toString();
                n.finalPrice = c.toString();
                this.getAllTotalPrice(n);
            },

            //计算每行总价
            getETotalPrice(x) {
                x.forEach((item, index) => {
                    item.totalPrice = new big(item.proNumber0).times(item.finalPrice0).toString();
                })
                this.tableData3 = x;
                this.getAllTotalPrice(this.tableData3);
            },

            //总价总和改变
            getAllTotalPrice() {
                this.allTotalPrice = 0;
                var aaa = 0;
                var bbb = 0;
                this.tableData3.forEach(function (val, index) {
                    aaa = new big(aaa).plus(val.totalPrice);
                })
                big.DP = 2;
                bbb = new big(aaa).div(1.3);
                this.allTotalPrice = aaa.toString();
                this.n.netPrice = bbb.toString();
                this.showMeYourMoney();
            },
            //下单金额扣除
            showMeYourMoney() {
                this.cashOccupy = this.creditOccupy = 0;
                if (this.allTotalPrice <= this.cashBalance) {
                    //现金足够扣现金
                    this.cashOccupy = this.allTotalPrice;
                    //现金不足扣信贷
                } else if (this.allTotalPrice > this.cashBalance) {
                    //现金全部扣完
                    this.cashOccupy = this.cashBalance;
                    //剩余部分扣信贷
                    this.creditOccupy = this.allTotalPrice - this.cashBalance;
                }
            },

            //订单审核
            orderPass(x) {
                x.taskId = this.q.taskid;
                x.orderId = this.tableData3.oid;
                ss.OrderService.orderPass(x).then(rd => {
                    console.log('审核流程结果', rd)
                });
                this.$router.push({path: '/thirdPage', query: {id: ''}});
            },

            //编辑按钮
            edit() {
                if (this.tableData3[0].orderStatus == '22' || this.tableData3[0].orderStatus == '23'
                    || this.tableData3[0].orderStatus == '10') {
                    this.clickActive = 2;
                } else {
                    this.$msg.msge('订单正在审核中或已通过审核,不允许修改!')
                }
            },

            //提交修改
            createNewOrder() {
                this.tableData2.submitflag = '重新提报';
                if (this.tableData3[0].orderStatus == '22' || this.tableData3[0].orderStatus == '23'
                    || this.tableData3[0].orderStatus == '10') {
                    //this.tableData2.orderId = this.q.orderId;
                    this.tableData2.instid = this.q.instid;
                    this.tableData2.orderProjectCode = this.formInline.id;
                    this.tableData2.orderData.currencyCode = this.currencyCode;
                    this.tableData2.orderData.orderCategory = this.formInline.orderCategory;
                    this.tableData2.orderCategory1 = this.formInline.orderCategory1;
                    this.tableData2.orderData.saleGroupCode = this.formInline.saleGroupCode;
                    this.tableData2.orderData.disChannelCode = this.formInline.disChannelCode;
                    this.tableData2.orderData.zCode = this.formInline.zCode;
                    this.tableData2.orderData.customerChannelCode = this.formInline.customerChannelCode;
                    this.tableData2.orderData.contactName = this.formInline.contactName;
                    this.tableData2.orderData.receivedTime = this.formInline.receivedTime;
                    this.tableData2.orderData.toAddress = this.formInline.toAddress;

                    this.tableData2.orderStatus = 20;
                    var list1 = [];
                    this.tableData3.forEach(function (val, index) {
                        var list2 = {};
                        list2.id = val.pid;
                        list2.materialCode = val.materialCode0;
                        list2.materialName = val.proModelCode0;
                        list2.proNumber = val.proNumber0;
                        list2.specialPrice = val.specialPrice;
                        list2.extraPrice = val.extraCssText;
                        list2.proBenchmarkPrice = val.proBenchmarkPrice0;
                        list2.finalPrice = val.finalPrice0;
                        list1.push(list2);
                    });
                    this.tableData2.orderProductList = list1;
                    console.log('t2',this.tableData2.orderProductList);
                    // prop="spare3"
                    // label="定制需求"
                    ss.OrderService.createNewOrder(this.tableData2).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.jump();
                    });
                    this.$router.push({path: "/dingd/myOrderList", query: {}})
                } else {
                    this.$msg.msge('只允许修改被驳回订单!')
                }
            }
        },

        data() {
            return {

                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },

                showhistory: false,
                showS: false,
                //审批流程开关
                showimg1: false,
                showimg2: false,
                showimg3: false,
                Dcolor: false,
                Fcolor: false,
                color: false,
                shouhou: false,
                fuwu: false,
                fukuan: false,

                isAA: true,
                isC: true,
                isB: true,
                isA: true,


                showPO: false,
                //订单审核相关数据
                tableData: {
                    orderStatus: '',
                    orderId: '',
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                },
                //创建订单数据
                tableData2: {
                    orderId: '',
                    orderStatus: '',
                    orderProjectCode: '',
                    orderData: {
                        currencyCode: '',
                        orderCategory: '',
                        saleGroupCode: '',
                        disChannelCode: '',
                        zCode: '',
                        customerChannelCode: '',
                        contactName: '',
                        receivedTime: '',
                        toAddress: '',
                    },
                    orderProductList: [],
                },
                tableData3: [],
                yincang: false,

                orderProjectName: '',
                orderMainContract: '',
                orderSubContract: '',
                currencyCode: '',

                flaag: true,
                //表单
                q: {
                    taskid: null,
                    orderId: '',
                },

                //表单
                c: {},
                //现金及信贷
                cashBalance: 0,
                cashOccupy: 0,
                creditBalance: 0,
                creditOccupy: 0,
                allTotalPrice: 0,

                n: {
                    netPrice: '',
                    quota: '',
                    id: '',
                    paymentdate: '',
                },

                params1: {
                    orderProductList: [],
                    saleGroupCode: '',
                    usercode: null,
                },

                //审批意见
                approOpinion: '',
                //审批提示信息
                tishixinxi: '',
                yijianbixutian: false,
                tejiashenpi: {
                    shenheyijian: '',
                },
                show: true,

                wxpo:"外销项目-PO",
                wxpi:"外销项目-PI",
                
                formInline: {
                    
                    orderProjectName: '',
                    saleGroupCode: '',
                    orderCategory: '',
                    orderCategory1: '',
                    disChannelCode: '',
                    zCode: '',
                    currencyCode: '',

                },
                message: '',
                value1: '',
                multipleSelection: [],
                clickActive: 1,
                formLabelAlign: {},

            };
        },
    }

</script>


